import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { IconButton, TableCell, TableRow } from '@mui/material';
import produce from 'immer';

import ClearIcon from '@mui/icons-material/Clear';
import PricesPropertyField from './PricesPropertyField';
import { PRICE_PROPERTIES, PRICE_PROPERTIES_LIST } from './constants';
import { getGroupedWithCountryPrices } from './util';

const PricesTableRow = ({ currentPricesData, priceData, setCurrentPrices, currency }) => {
  const groupedByCurrencyWithCountryPrices = useMemo(() => {
    const currentCurrencyPrices = currentPricesData.filter((price) => price.currency === currency)

    return getGroupedWithCountryPrices(currentCurrencyPrices);
  }, [currentPricesData, currency]);

  const handleCurrentPricePropertyChange = (ids) => (propertyName, newValue) => {
    setCurrentPrices(produce((draft) => {
      const pricesValues = draft.filter(({ id, uid }) => ids.includes(id) || ids.includes(uid));

      if (!pricesValues.length) return;

      pricesValues.forEach((priceValues) => {
        if (newValue || newValue === 0 || newValue === false) {
          priceValues[propertyName] = newValue;
        } else {
          delete priceValues[propertyName];
        }
      })
    }));
  };

  const handleCurrentPriceRemove = (ids) => () => {
    setCurrentPrices(
      (prev) => prev.filter(({ id, uid }) => (!ids.includes(id) && !ids.includes(uid)))
    );
  };

  return (groupedByCurrencyWithCountryPrices.map((groupedByCurrencyWithCountryPrice, rowIndex) => {
    const groupIds = groupedByCurrencyWithCountryPrice.map(({ id, uid }) => id || uid)

    return (
      <TableRow key={groupedByCurrencyWithCountryPrice.country} data-test="tableRow">
        {PRICE_PROPERTIES_LIST.map((propertyName) => ((propertyName !== PRICE_PROPERTIES.CURRENCY || !rowIndex) && (
          <TableCell
            key={propertyName}
            {...propertyName === PRICE_PROPERTIES.CURRENCY && {
              component: 'th',
              rowSpan: groupedByCurrencyWithCountryPrices.length,
              scope: 'row',
            }}
            align="center"
          >
            <PricesPropertyField
              propertyName={propertyName}
              currentPriceData={groupedByCurrencyWithCountryPrice[0]}
              rowPrices={groupedByCurrencyWithCountryPrice}
              currentPricesData={currentPricesData}
              priceData={priceData}
              setCurrentPrices={setCurrentPrices}
              onCurrentPricePropertyChange={handleCurrentPricePropertyChange(groupIds)}
            />
          </TableCell>
        )
      ))}
      <TableCell>
        <IconButton
          color="secondary"
          onClick={handleCurrentPriceRemove(groupIds)}
          size="large"
        >
          <ClearIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  )})
  );
};

const { array, func, string } = PropTypes;

PricesTableRow.propTypes = {
  currentPricesData: array,
  priceData: array,
  setCurrentPrices: func,
  currency: string,
};

export default PricesTableRow;
